<main>
    <div class="d-flex main-layout">
        <app-left-side-navbar class=""></app-left-side-navbar>
        <div class="main-container w-100">
          <app-navbar></app-navbar>
          <router-outlet></router-outlet>
        </div>
    </div>
</main>
